import Vue from 'vue'
import { ActionSheet, Toast, Collapse, CollapseItem, Dialog, Popup, Picker, Overlay, Loading, Empty, NumberKeyboard, Button, Col, Row, Tab, Tabs, Pagination, Icon, Progress, Cell, Sidebar, SidebarItem, NavBar, Popover, Divider, Field, CellGroup,List, Form, Area} from 'vant'

import 'vant/lib/index.css'

Vue.use(Empty)
Vue.use(Popup)
Vue.use(ActionSheet)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Picker)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Overlay)
Vue.use(Loading)
Vue.use(NumberKeyboard)
Vue.use(Button)
Vue.use(Col)
Vue.use(Row)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Cell)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(NavBar)
Vue.use(Popover)
Vue.use(Divider)
Vue.use(Field)
Vue.use(CellGroup)
Vue.use(List)
Vue.use(Form)
Vue.use(Area)